import styled from '@emotion/styled';

export type ItemType = {
  label?: string;
  value: string;
  isGroup?: boolean;
  items?: ItemType[];
};

export const Wrap = styled.div`
  position: relative;
  font-size: 14px;
`;
